export default __webpack_public_path__ + "static/media/GD.94ab2b90.svg";